import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { portalApi, PORTAL_TOKEN_KEY } from "@/lib/portalApi";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=authed

  const check = useCallback(async () => {
    const token = localStorage.getItem(PORTAL_TOKEN_KEY);
    if (!token) return setUser(false);
    try {
      const { data } = await portalApi.get("/portal/me");
      setUser(data);
    } catch {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const loginWithPassword = async (email, password) => {
    const { data } = await portalApi.post("/portal/auth/password", { email, password });
    localStorage.setItem(PORTAL_TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const requestMagicLink = async (email) => {
    const { data } = await portalApi.post("/portal/auth/magic-link", { email });
    return data;
  };

  const verifyMagicLink = async (token) => {
    const { data } = await portalApi.post("/portal/auth/verify", { token });
    localStorage.setItem(PORTAL_TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await portalApi.post("/portal/logout"); } catch { /* ignore */ }
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    setUser(false);
  };

  const refresh = check;

  return (
    <PortalAuthContext.Provider value={{
      user, loginWithPassword, requestMagicLink, verifyMagicLink, logout, refresh,
    }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used inside PortalAuthProvider");
  return ctx;
}
